module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-03.1.69ef9094.jpg";